// import React, { useState } from 'react';
// import {
//   Box, Button, TextField, Grid, Typography,
//   Divider, Checkbox, FormControlLabel, Select, MenuItem, Paper, InputLabel, FormControl
// } from "@mui/material";

// const styles = {
//   headerBg: "#FFD700",      // Bright Yellow
//   mainBg: "#6B5E00",        // Dark Olive Background from image
//   cardBg: "#FFFFFF",
//   textYellow: "#FFD700",
//   borderLight: "rgba(255, 255, 255, 0.1)",
//   confirmButton: "#FFD700", // Yellow confirm button
// };

// export default function PassengerDetailsPage() {
//   const [agreed, setAgreed] = useState(false);

//   // Mock data based on your "Pricing" box
//   const pricingData = {
//     seats: [
//       { id: "23", price: 5132.40 },
//       { id: "29", price: 5132.40 }
//     ],
//     tax: 13.10,
//     total: 10277.90
//   };

//   const cancellationPolicy = [
//     { time: "Between 05:00 on 13 Jan 2026 - 05:00 on 14 Jan 2026", charges: "30%" },
//     { time: "Till 05:00 on 13 Jan 2026", charges: "10%" },
//     { time: "Between 05:00 on 14 Jan 2026 - 17:00 on 14 Jan 2026", charges: "40%" },
//     { time: "Between 17:00 on 14 Jan 2026 - 21:00 on 14 Jan 2026", charges: "60%" },
//     { time: "After 21:00 on 14 Jan 2026", charges: "100%" },
//   ];

//   const PassengerForm = ({ number, seatId }) => (
//     <Paper elevation={0} sx={{ p: 3, mb: 3, borderRadius: 0 }}>
//       <Typography variant="h6" fontWeight="bold" sx={{ mb: 3 }}>Passenger {number}</Typography>
//       <Grid container spacing={3}>
//         <Grid item xs={12} md={4}>
//           <FormControl fullWidth variant="outlined">
//             <InputLabel>Title</InputLabel>
//             <Select label="Title" defaultValue="Mr.">
//               <MenuItem value="Mr.">Mr.</MenuItem>
//               <MenuItem value="Mrs.">Mrs.</MenuItem>
//               <MenuItem value="Ms.">Ms.</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>
//         <Grid item xs={12} md={4}>
//           <TextField fullWidth label="First Name" placeholder="First name" variant="outlined" />
//         </Grid>
//         <Grid item xs={12} md={4}>
//           <TextField fullWidth label="Last Name" placeholder="Last name" variant="outlined" />
//         </Grid>
//         <Grid item xs={12} md={4}>
//           <FormControl fullWidth variant="outlined">
//             <InputLabel>Gender</InputLabel>
//             <Select label="Gender" defaultValue="Male">
//               <MenuItem value="Male">Male</MenuItem>
//               <MenuItem value="Female">Female</MenuItem>
//               <MenuItem value="Other">Other</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>
//         <Grid item xs={12} md={4}>
//           <TextField fullWidth label="Age" placeholder="Age" variant="outlined" />
//         </Grid>
//         <Grid item xs={12} md={4}>
//           <TextField fullWidth label="Mobile" placeholder="HomePhone" variant="outlined" />
//         </Grid>
//         <Grid item xs={12} md={4}>
//           <TextField fullWidth label="Email" placeholder="Email" variant="outlined" />
//         </Grid>
//         <Grid item xs={12} md={4}>
//           <TextField fullWidth label="Address" placeholder="Address" variant="outlined" />
//         </Grid>
//         <Grid item xs={12} md={4}>
//           <TextField fullWidth label="Seat" value={seatId} InputProps={{ readOnly: true }} variant="outlined" />
//         </Grid>
//       </Grid>
//     </Paper>
//   );

//   return (
//     <Box sx={{ bgcolor: styles.mainBg, minHeight: '100vh', p: { xs: 2, md: 4 } }}>
//       <Grid container spacing={3}>

//         {/* Left Column: Forms */}
//         <Grid item xs={12} md={8.5} style={{width:"70%"}}>
//           {/* Header Info Card */}
//           <Paper elevation={0} sx={{ 
//             p: 0, mb: 3, borderRadius: 0, overflow: 'hidden',
//             background: 'linear-gradient(90deg, #4b3f00 0%, #7d6c00 100%)',
//             border: '1px solid rgba(255,255,255,0.2)'
//           }}>
//             <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//               <Box>
//                 <Typography variant="subtitle1" fontWeight="bold" color="white">Hans Travels (I) Private Limited</Typography>
//                 <Typography variant="caption" color="rgba(255,255,255,0.7)">Volvo 9600 Multi-Axle A/C Sleeper (2+1)</Typography>
//                 <Box sx={{ mt: 2, display: 'flex', gap: 4 }}>
//                   <Box>
//                     <Typography variant="caption" display="block" color="rgba(255,255,255,0.6)">Depart</Typography>
//                     <Typography color="white">15 Jan 2026, 17:00</Typography>
//                   </Box>
//                   <Box>
//                     <Typography variant="caption" display="block" color="rgba(255,255,255,0.6)">Arrival</Typography>
//                     <Typography color="white">18 Jan 2026, 10:08</Typography>
//                   </Box>
//                   <Box>
//                     <Typography variant="subtitle2" color={styles.headerBg}>Kolkata → Delhi</Typography>
//                     <Typography variant="caption" color="white">2 Seat(s)</Typography>
//                   </Box>
//                 </Box>
//               </Box>
//               <Box component="img" src="https://via.placeholder.com/100x60" sx={{ opacity: 0.8 }} />
//             </Box>
//             <Box sx={{ bgcolor: 'rgba(255,255,255,0.1)', p: 1.5 }}>
//                <Typography variant="caption" color="rgba(255,255,255,0.8)">
//                  As soon as your booking is confirmed, a confirmation e-mail containing your booking details would be sent...
//                </Typography>
//             </Box>
//           </Paper>

//           {/* Passenger Forms */}
//           <PassengerForm number={1} seatId="23" />
//           <PassengerForm number={2} seatId="29" />

//           {/* Cancellation Policy */}
//           <Paper elevation={0} sx={{ p: 3, mb: 3, borderRadius: 0 }}>
//             <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>Cancellation Policy</Typography>
//             <Grid container sx={{ borderBottom: '1px solid #eee', pb: 1, mb: 1 }}>
//               <Grid item xs={8}><Typography variant="subtitle2" color="gray">Cancellation time</Typography></Grid>
//               <Grid item xs={4}><Typography variant="subtitle2" color="gray">Cancellation charges</Typography></Grid>
//             </Grid>
//             {cancellationPolicy.map((item, index) => (
//               <Grid container key={index} sx={{ py: 0.5 }}>
//                 <Grid item xs={8}><Typography variant="body2">{item.time}</Typography></Grid>
//                 <Grid item xs={4}><Typography variant="body2">{item.charges}</Typography></Grid>
//               </Grid>
//             ))}
//           </Paper>

//           {/* Final Booking Card */}
//           <Paper elevation={0} sx={{ p: 3, borderRadius: 0 }}>
//              <Typography variant="h6" fontWeight="bold">Review and book your trip</Typography>
//              <Typography variant="body2" sx={{ my: 1 }}>
//                Total Amount <strong>₹{pricingData.total.toLocaleString()}</strong> (including taxes and fees)
//              </Typography>
//              <Typography variant="caption" color="gray" display="block" sx={{ mb: 2 }}>
//                Credit card WILL BE CHARGED IMMEDIATELY FOR THE FULL AMOUNT of the reservation
//              </Typography>

//              <FormControlLabel 
//                control={<Checkbox checked={agreed} onChange={(e) => setAgreed(e.target.checked)} size="small" />} 
//                label={<Typography variant="body2">I agree with the <span style={{color: 'blue', textDecoration: 'underline', cursor: 'pointer'}}>Terms & Conditions</span> and I understand and accept the cancellation policy</Typography>}
//              />

//              <Button 
//                variant="contained" 
//                fullWidth 
//                disabled={!agreed}
//                sx={{ 
//                  mt: 3, bgcolor: styles.confirmButton, color: 'black', fontWeight: 'bold', height: '50px',
//                  fontSize: '1.1rem', '&:hover': { bgcolor: '#e6c200' }, borderRadius: '4px'
//                }}
//              >
//                Confirm Booking
//              </Button>
//           </Paper>
//         </Grid>

//         {/* Right Column: Pricing Summary */}
//         <Grid item xs={12} md={3.5} style={{width:"27%"}}>
//           <Paper elevation={0} sx={{ borderRadius: 0, overflow: 'hidden' }}>
//             <Box sx={{ p: 2, borderBottom: '1px solid #eee' }}>
//               <Typography variant="h6" fontWeight="bold">Pricing</Typography>
//             </Box>
//             <Box sx={{ p: 2 }}>
//               {pricingData.seats.map(seat => (
//                 <Box key={seat.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
//                   <Typography variant="body2">Seat ({seat.id})</Typography>
//                   <Typography variant="body2">₹{seat.price.toFixed(2)}</Typography>
//                 </Box>
//               ))}
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
//                 <Typography variant="body2">Tax</Typography>
//                 <Typography variant="body2">₹{pricingData.tax.toFixed(2)}</Typography>
//               </Box>
//             </Box>
//             <Box sx={{ p: 2, bgcolor: '#f0f7ff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <Typography variant="h6" fontWeight="bold">Total Amount</Typography>
//               <Typography variant="h6" fontWeight="bold">₹{pricingData.total.toFixed(2)}</Typography>
//             </Box>
//           </Paper>
//         </Grid>

//       </Grid>

//       {/* Footer Branding */}
//       <Box sx={{ mt: 8, textAlign: 'center', color: 'white', pb: 4 }}>
//          <Typography variant="caption">© 2026 Jayraj Group. All rights reserved.</Typography>
//       </Box>
//     </Box>
//   );
// }

import React, { useState, useEffect, useCallback, memo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box, Button, TextField, Grid, Typography,
  Divider, Checkbox, FormControlLabel, Select, MenuItem, Paper,
  InputLabel, FormControl, CircularProgress, Alert, Snackbar
} from "@mui/material";
import axios from 'axios';
import { toast } from 'react-toastify';
import api from "../../../Api.js"

const styles = {
  headerBg: "#FFD700",
  mainBg: "#6B5E00",
  cardBg: "#FFFFFF",
  textYellow: "#FFD700",
  borderLight: "rgba(255, 255, 255, 0.1)",
  confirmButton: "#FFD700",
};

// --- PassengerForm Component moved OUTSIDE ---
const PassengerForm = memo(({ passenger, index, onChange }) => (
  <Paper elevation={0} sx={{ p: 3, mb: 3, borderRadius: 0 }}>
    <Typography variant="h6" fontWeight="bold" sx={{ mb: 3 }}>
      Passenger {index + 1} {passenger.isLeadPassenger && "(Lead Passenger)"}
    </Typography>
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>Title</InputLabel>
          <Select
            label="Title"
            value={passenger.title || 'Mr'}
            onChange={(e) => onChange(index, 'title', e.target.value)}
          >
            <MenuItem value="Mr">Mr.</MenuItem>
            <MenuItem value="Mrs">Mrs.</MenuItem>
            <MenuItem value="Ms">Ms.</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          label="First Name"
          variant="outlined"
          size="small"
          value={passenger.firstName || ''}
          onChange={(e) => onChange(index, 'firstName', e.target.value)}
          required
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          label="Last Name"
          variant="outlined"
          size="small"
          value={passenger.lastName || ''}
          onChange={(e) => onChange(index, 'lastName', e.target.value)}
          required
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>Gender</InputLabel>
          <Select
            label="Gender"
            value={passenger.gender || 1}
            onChange={(e) => onChange(index, 'gender', parseInt(e.target.value))}
          >
            <MenuItem value={1}>Male</MenuItem>
            <MenuItem value={2}>Female</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          label="Age"
          variant="outlined"
          size="small"
          type="number"
          value={passenger.age || ''}
          onChange={(e) => onChange(index, 'age', e.target.value)}
          required
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          label="Mobile"
          variant="outlined"
          size="small"
          value={passenger.phone || ''}
          onChange={(e) => onChange(index, 'phone', e.target.value)}
          required
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          label="Email"
          variant="outlined"
          size="small"
          type="email"
          value={passenger.email || ''}
          onChange={(e) => onChange(index, 'email', e.target.value)}
          required
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          label="Address"
          variant="outlined"
          size="small"
          value={passenger.address || ''}
          onChange={(e) => onChange(index, 'address', e.target.value)}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          label="Seat"
          value={passenger.seatNumber || ''}
          InputProps={{ readOnly: true }}
          variant="outlined"
          size="small"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>ID Type</InputLabel>
          <Select
            label="ID Type"
            value={passenger.idType || ''}
            onChange={(e) => onChange(index, 'idType', e.target.value)}
          >
            <MenuItem value="">None</MenuItem>
            <MenuItem value="aadhaar">Aadhaar</MenuItem>
            <MenuItem value="pan">PAN</MenuItem>
            <MenuItem value="voter">Voter ID</MenuItem>
            <MenuItem value="passport">Passport</MenuItem>
            <MenuItem value="dl">Driving License</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          label="ID Number"
          variant="outlined"
          size="small"
          value={passenger.idNumber || ''}
          onChange={(e) => onChange(index, 'idNumber', e.target.value)}
        />
      </Grid>
    </Grid>
  </Paper>
));

PassengerForm.displayName = 'PassengerForm';

// --- Main Page Component ---
export default function PassengerDetailsPage() {

  const location = useLocation();
  const navigate = useNavigate();
  const [blockResponse, setBlockResponse] = useState(null);
  const accessToken = localStorage.getItem("accessToken");
  console.log("accessToken : ", accessToken)
  // Get data from navigation state
  const {
    bus,
    selectedSeats,
    selectedSeatDetails,
    seatLayout,
    boardingPoint,
    droppingPoint,
    totalPrice,
    searchData,
    traceId,
    origin,
    destination,
    departDate
  } = location.state || {};

  console.log("Passenger Details Page - Received Data:", location.state);

  // States
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [passengers, setPassengers] = useState([]);

  const cancellationPolicy = [
    { time: "Between 05:00 on 13 Jan 2026 - 05:00 on 14 Jan 2026", charges: "30%" },
    { time: "Till 05:00 on 13 Jan 2026", charges: "10%" },
    { time: "Between 05:00 on 14 Jan 2026 - 17:00 on 14 Jan 2026", charges: "40%" },
    { time: "Between 17:00 on 14 Jan 2026 - 21:00 on 14 Jan 2026", charges: "60%" },
    { time: "After 21:00 on 14 Jan 2026", charges: "100%" },
  ];

  // Initialize passengers
  useEffect(() => {
    if (selectedSeats && selectedSeats.length > 0) {
      const initialPassengers = selectedSeats.map((seatId, index) => ({
        id: index + 1,
        seatNumber: seatId,
        title: 'Mr',
        firstName: '',
        lastName: '',
        email: '',
        address: '',
        gender: 1,
        age: '',
        idType: '',
        idNumber: '',
        phone: '',
        isLeadPassenger: index === 0,
        seatDetails: selectedSeatDetails?.find(seat => seat.SeatName === seatId) || null
      }));
      setPassengers(initialPassengers);
    }
  }, [selectedSeats, selectedSeatDetails]);

  // Handle passenger change
  const handlePassengerChange = useCallback((index, field, value) => {
    setPassengers(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  }, []);

  // Calculate pricing
  const calculatePricing = () => {
    if (!passengers.length) return { subtotal: 0, tax: 0, total: 0 };

    // 1. Calculate Subtotal (Sum of all PublishedPrices)
    const subtotal = passengers.reduce((sum, p) => {
      // Accessing the PublishedPrice from the nested Price object
      const fare = p.seatDetails?.Price?.PublishedPrice || 0;
      return sum + fare;
    }, 0);

    const totalTax = passengers.reduce((sum, p) => {
      const gstObj = p.seatDetails?.Price?.GST;
      const individualTax = (gstObj?.CGSTAmount || 0) + (gstObj?.IGSTAmount || 0) + (gstObj?.CessAmount || 0);
      return sum + individualTax;
    }, 0);

    const total = subtotal + totalTax;

    return { subtotal, totalTax, total };
  };


  const pricingData = calculatePricing();

  // Validate form
  const validateForm = () => {
    for (const p of passengers) {
      if (!p.firstName.trim() || !p.lastName.trim()) return 'First and Last name are required for all passengers';
      if (!p.email.trim() || !/\S+@\S+\.\S+/.test(p.email)) return 'Valid email is required for all passengers';
      if (!p.age || p.age < 1 || p.age > 100) return 'Valid age (1-100) is required';
      if (!p.phone || p.phone.length < 10) return 'Valid phone number is required';
    }
    return '';
  };

  // Prepare passenger data for API
  const preparePassengerData = () => {
    return passengers.map((p, index) => ({
      LeadPassenger: p.isLeadPassenger,
      PassengerId: index + 1,
      Title: p.title,
      FirstName: p.firstName,
      LastName: p.lastName,
      Email: p.email,
      Address: p.address || 'N/A',
      Gender: p.gender,
      Age: p.age.toString(),
      IdType: p.idType || null,
      IdNumber: p.idNumber || null,
      Phoneno: p.phone,
      Seat: p.seatDetails ? { ...p.seatDetails, SeatName: p.seatNumber } : null
    }));
  };

  // Block Bus API
  const blockBusAPI = async () => {
    try {
      if (accessToken === null) {
        return;
      }
      const passengerData = preparePassengerData();


      const blockBusData = {
        action: "blockBus",
        origin_name: origin || searchData?.from?.name || "Unknown",
        destination_name: destination || searchData?.to?.name || "Unknown",
        depart_date: departDate || searchData?.date || "2026-01-18",
        TraceId: traceId,
        ResultIndex: bus?.ResultIndex?.toString() || "0",
        BoardingPointId: boardingPoint?.CityPointIndex?.toString() || "1",
        DroppingPointId: droppingPoint?.CityPointIndex?.toString() || "1",
        Passenger: passengerData
      };

      console.log("Block Bus API Request:", blockBusData);



      const response = await api.post('/bus/block-bus', blockBusData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        }
      });

      console.log("Block Bus API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error('Block Bus API Error:', error);
      throw error;
    }
  };


  const bookBusAPI = async (blockResponseData) => {
    try {
      const blockResult = blockResponseData;
      console.log("blockResult........... : ", blockResult);
      console.log("blockResult...........blockResult.TraceId : ", blockResult.TraceId);
      console.log("blockResult........... blockResult.Passenger: ", blockResult.Passenger);

      const apiData = blockResponseData?.data?.responseData?.BlockResult;
      const bookBusData = {
        action: "bookBus",
        origin_name: origin || searchData?.from?.name,
        destination_name: destination || searchData?.to?.name,
        depart_date: departDate || searchData?.date,
        TraceId: blockResponseData?.TraceId || apiData?.TraceId,
        ResultIndex: bus?.ResultIndex?.toString() || apiData?.ResultIndex?.toString(),
        BoardingPointId: boardingPoint?.CityPointIndex?.toString() || apiData?.BoardingPointId?.toString(),
        DroppingPointId: droppingPoint?.CityPointIndex?.toString() || apiData?.DroppingPointId?.toString(),
        Passenger: apiData?.Passenger || blockResponseData?.Passenger,
        order_id: apiData?.order_id,
      };

      // RETURN A PROMISE THAT RESOLVES WHEN THE PAYMENT IS SUCCESSFULLY VERIFIED AND BOOKING IS DONE
      return new Promise((resolve, reject) => {
        const options = {
          key: blockResult?.data?.responseData?.BlockResult?.razorpay_key,
          amount: pricingData.total.toLocaleString('en-IN', { minimumFractionDigits: 2 }),
          currency: "INR",
          name: "My Store",
          description: "Test Transaction",
          order_id: blockResult?.data?.responseData?.BlockResult?.razorpay_order_id,
          handler: async function (response) {
            console.log("response,", response);
            const verifyPayload = {
              order_id: blockResult?.data?.responseData?.BlockResult?.order_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature
            };
            console.log("verifyPayload:", verifyPayload);


            try {
              const verifyRes = await api.post('/payments/razorpay/verify-bus', verifyPayload, {
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                  'Content-Type': 'application/json',
                }
              });

              console.log("verifyRes:", verifyRes);

              if (verifyRes?.data?.status === true) {
                console.log("Book Bus API Final Request:", bookBusData);

                const bookResponse = await api.post(
                  "/bus/book-bus",
                  bookBusData,
                  {
                    headers: {
                      Authorization: `Bearer ${accessToken}`,
                      Accept: "application/json",
                    },
                  }
                );
                console.log("Book Bus response......... : ", bookResponse);

                // RESOLVE THE PROMISE WITH THE BOOKING RESPONSE
                resolve(bookResponse);
              } else {
                reject(new Error("Payment verification failed"));
              }
            } catch (err) {
              console.error("Error in payment/booking process:", err);
              alert("Error verifying payment");
              reject(err);
            }
          },
          prefill: {
            name: "Akash Shaikh",
            email: "akash@example.com",
            contact: "9999999999",
          },
          theme: {
            color: "#3399cc",
          },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
        console.log("Razorpay modal opened");

        // Handle modal close without payment
        rzp.on('payment.failed', function (response) {
          console.error("Payment failed:", response.error);
          reject(new Error("Payment failed or was cancelled"));
        });
      });

    } catch (error) {
      console.error('Book Bus API Error:', error);
      throw error;
    }
  };

  // 2. Modified handler to chain them correctly
  const handleConfirmBooking = async () => {
    if (!agreed) { setError('Please agree to T&C'); return; }

    try {
      setLoading(true);

      // STEP 1: Block the bus
      const blockResult = await blockBusAPI();
      console.log("blockResult.... : ", blockResult)
      if (blockResult?.status) {
        setSuccess('Seat blocked... finalizing booking...');

        // STEP 2: Use the DATA returned from blockResult to call Book Bus
        const bookResult = await bookBusAPI(blockResult);
        console.log("bookResult ???????? : ", bookResult)
        if (bookResult?.data?.status === true) {
          // setSuccess('Booking confirmed successfully!');
          toast.success("Booking confirmed successfully!")
          navigate("/profile/Bus-info", { replace: true });
        } else {
          setError(bookResult.message || 'Booking failed at supplier.');
        }
      } else {
        setError('Failed to block seat. It might be sold out.');
      }
    } catch (err) {
      setError('An unexpected error occurred.');
    } finally {
      setLoading(false);
    }
  };



  if (!bus || !selectedSeats || selectedSeats.length === 0) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: styles.mainBg
      }}>
        <Typography variant="h6" color="white">
          No booking data found. Please go back and select a bus.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ bgcolor: styles.mainBg, minHeight: '100vh', p: { xs: 2, md: 4 } }}>
      {/* Error/Success Messages */}
      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={() => setError('')}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setError('')} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>

      <Snackbar
        open={!!success}
        autoHideDuration={6000}
        onClose={() => setSuccess('')}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setSuccess('')} severity="success" sx={{ width: '100%' }}>
          {success}
        </Alert>
      </Snackbar>

      <Grid container spacing={3}>

        {/* Left Column: Forms */}
        <Grid item xs={12} md={8.5} style={{ width: "70%" }}>
          {/* Header Info Card */}
          <Paper elevation={0} sx={{
            p: 0, mb: 3, borderRadius: 0, overflow: 'hidden',
            background: 'linear-gradient(90deg, #4b3f00 0%, #7d6c00 100%)',
            border: '1px solid rgba(255,255,255,0.2)'
          }}>
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <Box>
                <Typography variant="subtitle1" fontWeight="bold" color="white">
                  {bus.TravelName || "Unknown Travels"}
                </Typography>
                <Typography variant="caption" color="rgba(255,255,255,0.7)">
                  {bus.BusType || "Bus Type Not Available"}
                </Typography>
                <Box sx={{ mt: 2, display: 'flex', gap: 4 }}>
                  <Box>
                    <Typography variant="caption" display="block" color="rgba(255,255,255,0.6)">Depart</Typography>
                    <Typography color="white">
                      {new Date(bus.DepartureTime).toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric'
                      })}, {new Date(bus.DepartureTime).toLocaleTimeString('en-US', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false
                      })}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" display="block" color="rgba(255,255,255,0.6)">Arrival</Typography>
                    <Typography color="white">
                      {new Date(bus.ArrivalTime).toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric'
                      })}, {new Date(bus.ArrivalTime).toLocaleTimeString('en-US', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false
                      })}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color={styles.headerBg}>
                      {origin || searchData?.from?.name} → {destination || searchData?.to?.name}
                    </Typography>
                    <Typography variant="caption" color="white">
                      {selectedSeats.length} Seat(s)
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ mt: 1 }}>
                  <Typography variant="caption" color="rgba(255,255,255,0.8)">
                    Boarding: {boardingPoint?.CityPointName} |
                    Dropping: {droppingPoint?.CityPointName}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box sx={{ bgcolor: 'rgba(255,255,255,0.1)', p: 1.5 }}>
              <Typography variant="caption" color="rgba(255,255,255,0.8)">
                As soon as your booking is confirmed, a confirmation e-mail containing your booking details would be sent...
              </Typography>
            </Box>
          </Paper>

          {/* Passenger Forms */}
          {passengers.map((p, i) => (
            <PassengerForm
              key={p.id}
              passenger={p}
              index={i}
              onChange={handlePassengerChange}
            />
          ))}

          {/* Cancellation Policy */}
          <Paper elevation={0} sx={{ p: 3, mb: 3, borderRadius: 0 }}>
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>Cancellation Policy</Typography>
            <Grid container sx={{ borderBottom: '1px solid #eee', pb: 1, mb: 1 }}>
              <Grid item xs={8}><Typography variant="subtitle2" color="gray">Cancellation time</Typography></Grid>
              <Grid item xs={4}><Typography variant="subtitle2" color="gray">Cancellation charges</Typography></Grid>
            </Grid>
            {cancellationPolicy.map((item, index) => (
              <Grid container key={index} sx={{ py: 0.5 }}>
                <Grid item xs={8}><Typography variant="body2">{item.time}</Typography></Grid>
                <Grid item xs={4}><Typography variant="body2">{item.charges}</Typography></Grid>
              </Grid>
            ))}
          </Paper>

          {/* Final Booking Card */}
          <Paper elevation={0} sx={{ p: 3, borderRadius: 0 }}>
            <Typography variant="h6" fontWeight="bold">Review and book your trip</Typography>
            <Typography variant="body2" sx={{ my: 1 }}>
              Total Amount <strong>₹{pricingData.total.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</strong> (including taxes and fees)
            </Typography>
            <Typography variant="caption" color="gray" display="block" sx={{ mb: 2 }}>
              Credit card WILL BE CHARGED IMMEDIATELY FOR THE FULL AMOUNT of the reservation
            </Typography>

            <FormControlLabel
              control={
                <Checkbox
                  checked={agreed}
                  onChange={(e) => setAgreed(e.target.checked)}
                  size="small"
                  disabled={loading}
                />
              }
              label={
                <Typography variant="body2">
                  I agree with the <span style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}>Terms & Conditions</span> and I understand and accept the cancellation policy
                </Typography>
              }
            />

            <Button
              variant="contained"
              fullWidth
              disabled={!agreed || loading}
              onClick={handleConfirmBooking}
              sx={{
                mt: 3, bgcolor: styles.confirmButton, color: 'black', fontWeight: 'bold', height: '50px',
                fontSize: '1.1rem', '&:hover': { bgcolor: '#e6c200' }, borderRadius: '4px'
              }}
            >
              {loading ? (
                <CircularProgress size={24} sx={{ color: 'black' }} />
              ) : (
                'Confirm Booking'
              )}
            </Button>
          </Paper>
        </Grid>

        {/* Right Column: Pricing Summary */}
        <Grid item xs={12} md={3.5} style={{ width: "27%" }}>
          <Paper elevation={0} sx={{ borderRadius: 0, overflow: 'hidden', border: '1px solid #eee' }}>
            <Box sx={{ p: 2, borderBottom: '1px solid #eee' }}>
              <Typography variant="h6" fontWeight="bold">Pricing</Typography>
            </Box>

            <Box sx={{ p: 2 }}>
              {/* Individual Seats */}
              {passengers.map((passenger) => {
                const seatFare = passenger.seatDetails?.Price?.PublishedPrice || 0;
                return (
                  <Box key={passenger.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="body2">Seat ({passenger.seatNumber})</Typography>
                    <Typography variant="body2">₹{seatFare.toFixed(2)}</Typography>
                  </Box>
                );
              })}

              {/* Separator Line */}
              <Box sx={{ my: 1.5, borderTop: '1px dashed #ddd' }} />

              {/* Taxable Amount Row */}
              {pricingData.taxableAmount > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography variant="body2" color="text.secondary">
                    Taxable Amount (GST)
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    ₹{pricingData.taxableAmount.toFixed(2)}
                  </Typography>
                </Box>
              )}
            </Box>

            {/* Total Amount Section */}
            <Box sx={{ p: 2, bgcolor: '#f0f7ff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h6" fontWeight="bold">Total Amount</Typography>
              <Typography variant="h6" fontWeight="bold">₹{pricingData.total.toFixed(2)}</Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>

    </Box>
  );
}